import { render } from "./UserCouponList.vue?vue&type=template&id=0b95bf5f&scoped=true"
import script from "./UserCouponList.vue?vue&type=script&lang=js"
export * from "./UserCouponList.vue?vue&type=script&lang=js"

import "./UserCouponList.vue?vue&type=style&index=0&id=0b95bf5f&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b95bf5f"]])

export default __exports__